import { atom } from 'jotai';

import { automationVersionsListQueryAtom } from '../_graphql/queryAutomationVersions';
import { automationsRoutes } from '../routes';

import { atomFromRoutePath } from '~/shared/state/location.state';

const $versionHistoryIdFromRoute = atomFromRoutePath(automationsRoutes.detail);

export const $versionsAutomationId = atom((get) => {
  const params = get($versionHistoryIdFromRoute) as { id?: string } | null;
  const id = params?.id;
  return id && id !== 'new' ? String(id) : undefined;
});

export const $remoteAutomationVersions = automationVersionsListQueryAtom(
  (get) => {
    const automationId = get($versionsAutomationId);
    return {
      variables: { automationId: automationId ?? '' },
      skip: !automationId,
    };
  },
);
